import { render, staticRenderFns } from "./corporacion.vue?vue&type=template&id=441dd91b"
import script from "./corporacion.vue?vue&type=script&lang=js"
export * from "./corporacion.vue?vue&type=script&lang=js"
import style0 from "./corporacion.vue?vue&type=style&index=0&id=441dd91b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports